import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSiteCopy } from "@/lib/copy";

const DEFAULT_ABOUT = `Fix It Aquatics, LLC started in a battered pickup truck and a single client's backyard. We're the people you call when the water has gone wrong, or when you want it to feel exactly right from day one.

We design, build, repair and care for pools the way a luthier looks after a guitar: small, fussy moves that make a big difference.

We work with homeowners, designers, and a quiet circle of properties that prefer not to be named. We treat all of them the same, like the project matters.`;

export default function About() {
  const t = useSiteCopy();
  const [text, setText] = useState(DEFAULT_ABOUT);

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => { if (r.data?.about?.trim()) setText(r.data.about); })
      .catch(() => {});
  }, []);

  const paragraphs = text.split(/\n\s*\n/).filter(Boolean);

  return (
    <div className="mx-auto max-w-5xl px-5 py-16 md:px-8 md:py-24">
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">{t("about.eyebrow", "Our story")}</span>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900 md:text-5xl wavy">{t("about.title", "A small crew, an obsession with water.")}</h1>
      <div className="mt-10 grid gap-12 md:grid-cols-2">
        <div className="prose prose-slate max-w-none text-slate-700" data-testid="about-story-text">
          {paragraphs.map((p) => (
            <p key={p.slice(0, 60)} className="whitespace-pre-line">{p}</p>
          ))}
        </div>
        <div className="space-y-5">
          {[
            [t("about.card1_title", "Licensed CPO® team"), t("about.card1_text", "Certified Pool Operators on every crew, all season.")],
            [t("about.card2_title", "Same-day response"), t("about.card2_text", "We aim for same-business-day quotes and 48hr service visits.")],
            [t("about.card3_title", "Quiet, careful work"), t("about.card3_text", "Tarps, drop-cloths, and tidy equipment pads — every visit.")],
          ].map(([k, v]) => (
            <div key={k} className="rounded-2xl border border-cyan-100 bg-white p-5">
              <div className="font-display text-lg font-bold text-slate-900">{k}</div>
              <div className="mt-1 text-slate-600">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
